import moment from 'moment';

function PrintMetadata() {
  const today = moment(new Date().toString()).format('MMMM DD, YYYY');

  return <div className="hidden print:block">{`Created on: ${today}`}</div>;
}

export default PrintMetadata;
